<template lang="pug">
    v-dialog(v-model='dialog', persistent, max-width='600px')
        template(v-slot:activator='{ on }')
            v-btn( icon small v-on='on' v-if="edit" @click="importUser(user)") 
              v-icon mdi-pencil
            v-btn(text color="accent" v-on='on' v-else) 
              v-icon.mr-2 mdi-plus
              | {{ $t("users.add")}}
        v-form(ref="form", v-model="valid", @submit.prevent="createUserFunction", lazy-validation=false)
          v-card
            v-card-title {{edit ? $t("users.editTitle") : $t("users.createTitle")}}
            v-card-text.text-center.pb-12(v-if="temporaryPassword")
              h4.mb-2 Password: 
              code.py-2.px-8 {{ temporaryPassword }}

              h4.mt-12 Send Email:
              v-text-field(rounded filled :value='`https://app.simplymotion.de/activate?email=${createUser.email}&pw=${temporaryPassword}`' ref='textToCopy')
              v-btn(@click='copyText' depressed) copy

            v-card-text(v-else)
                  v-text-field(v-model='createUser.givenName', :disabled="edit" filled rounded :label='$t("auth.forms.firstName")')
                  v-text-field(v-model='createUser.familyName', :disabled="edit" filled rounded :label='$t("auth.forms.lastName")')
                  v-text-field(:label='$t("auth.forms.email")', filled rounded v-model="createUser.email" :rules="[required, email]", :disabled="edit" required)

                  v-select(v-model='createUser.tenantId', filled rounded :items='tenants', item-text="name" item-value="id" :rules="[required]", :label='$t("auth.forms.tenant")' outline)
                  v-select(v-model='createUser.tenantRole', filled rounded :items='tenantRoles', :rules="[required]", label='Roles', outline)
            
            v-divider
            v-card-actions
                v-spacer
                v-btn(text, @click='closeDialog' v-if="!temporaryPassword") {{$t("general.cancel")}}
                v-btn(color='accent', text, type="submit" :disabled="!valid" v-if="!temporaryPassword")  {{edit ? $t("general.save") : $t("users.createTitle")}}
                v-btn(color='accent', text, v-else @click='closeDialog')   {{$t("general.close")}}
</template>
<script>
import { mapState } from "vuex";
import validations from "@/utils/validations";
export default {
  props: ["edit", "user", "tenantId"],
  data() {
    return {
      dialog: false,
      showPassword: false,
      createUser: {
        username: "",
        givenName: "",
        familyName: "",
        email: "",
        tenantId: this.tenantId,
        tenantRole: "TENANT_USER",
      },
      tenantRoles: ["TENANT_ADMIN", "TENANT_USER"],
      ...validations,
      valid: false,
      temporaryPassword: null,
    };
  },
  computed: {
    ...mapState({ tenants: (state) => state.superAdmin.tenants }),
  },
  async mounted() {
    if (this.tenants.length <= 0) {
      this.$store.dispatch("superAdmin/FETCH_TENANTS");
    }
  },
  methods: {
    importUser(user) {
      this.createUser = {
        username: user.Username,
        givenName: user.Attributes.given_name,
        familyName: user.Attributes.family_name,
        email: user.Attributes.email,
        tenantRole: user.Attributes["custom:tenantRole"],
        tenantId: user.Attributes["custom:tenantId"],
      };
    },
    closeDialog() {
      this.dialog = false;
      this.createUser = {
        username: "",
        givenName: "",
        familyName: "",
        email: "",
        tenantId: "",
        tenantRole: "",
      };
      this.temporaryPassword = null;
    },
    async createUserFunction() {
      if (this.edit) {
        await this.$store.dispatch("superAdmin/UPDATE_USER", this.createUser);
        this.closeDialog();
      } else {
        const response = await this.$store.dispatch(
          "superAdmin/CREATE_USER",
          this.createUser
        );
        if (response && response.message == "Created user") {
          this.temporaryPassword = response.temporaryPassword;
        }
      }
    },
    copyText() {
      let textToCopy = this.$refs.textToCopy.$el.querySelector("input");
      textToCopy.select();
      document.execCommand("copy");
    },
  },
};
</script>
